var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isShow && _vm.headerShow)?_c('Header',{ref:"pageHeader"}):_vm._e(),_c('keep-alive',{attrs:{"include":"class","max":10}},[(_vm.isShow)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()],1),(_vm.footerShow)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }